/* eslint-disable no-console */
import { mergeLinesToCollections } from "@app/components/order/Products/Products"
import { appStore } from "@app/store/store"
import { ApiErrorHandler } from "@app/utils/apiErrorHandler"
import { ADRESS_TYPES, ORDER_LINE_TYPES, PAYMENT_TYPES, SCANCODE_TYPES } from "@app/utils/constants"
import localStore from "@app/utils/localStore"
import { emptyArray, groupBy } from "@app/utils/objectUtils"
import tracking from "@app/utils/tracking"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { ResponseError, createApi, createBaseQuery } from "@tecreation/js-state-react"
import { refreshToken } from "./authService"

const baseQueryOptions = {
	baseUrl: () => {
		return "/api/connector"
	},
	prepareHeaders: headers => {
		headers.set("apiKey", appStore.get("settings.connectorKey"))
		headers.set("Accept", "application/json")
		if (appStore.get("core.accessToken")) {
			headers.set("Authorization", "Bearer " + appStore.get("core.accessToken"))
		}
		if (headers.get("content-type") == null && headers.get("enctype") !== "multipart/form-data") {
			headers.set("content-type", "application/json")
		}

		return headers
	},
	onError: ApiErrorHandler,
	requestInterceptor: async (response, refetch, requestInit, _params, _body) => {
		let nextResponse = response
		if (response.status == 401 && !requestInit.url.endsWith("/refresh")) {
			var reAuth = await refreshToken()
			if (reAuth.succeed == true) {
				nextResponse = await refetch()
			}
		}
		return nextResponse
	},
}

export const connectorApiSlice = createApi("connectorApi", appStore, createBaseQuery(baseQueryOptions), {
	keepUnusedDataFor: 360,
})

export const useGetFunnel = connectorApiSlice.query({
	builder: () => ({
		url: "funnel",
		params: {
			funnelToken: appStore.get("settings.funnelToken"),
		},
	}),
})

export const usePostStackTrace = connectorApiSlice.mutation({
	builder: ({ body, message, uri, db, stackTrace }) => {
		return {
			url: "error/trace",
			body: {
				body,
				message,
				uri,
				db,
				stackTrace,
			},
		}
	},
})
export const useGetOrderKind = connectorApiSlice.query({
	builder: () => ({
		url: "sales/orderKind",
		params: {
			funnelToken: appStore.get("settings.funnelToken"),
		},
	}),
	transformResponse: response => {
		response.data = response.data[0]
		return response
	},
})

export const useGetSalutations = connectorApiSlice.query({
	builder: () => ({
		url: "relation/salutation",
		params: {
			languageCode: appStore.get("core.languageCode"),
		},
	}),
	transformResponse: response => {
		response.data.forEach((e, i, a) => {
			a[i] = {
				...e,
				id: e.genderId,
				value: e.genderId,
				name: e.translation ? e.translation.title || e.salutation : e.salutation,
			}
		})
		return response
	},
})

export const useGetActivitesConnector = connectorApiSlice.query({
	builder: () => ({
		url: "Activity",
		params: {
			funnelToken: appStore.get("settings.funnelToken"),
		},
	}),
})

export const useCheckActivityAvailablity = connectorApiSlice.mutation({
	builder: ({ activityId, date, time }) => {
		console.log(time)
		let startDate = new Date(date)
		startDate.setHours(0)
		startDate.setMinutes(0)

		let endDate = new Date(date)
		endDate.setHours(23)
		endDate.setMinutes(59)

		if (time.from) {
			let timeS = time.from.split(":")
			startDate.setHours(timeS[0] || 0)
			startDate.setMinutes(timeS[1] || 0)
		}
		if (time.to) {
			let timeS = time.to.split(":")
			endDate.setHours(timeS[0] || 0)
			endDate.setMinutes(timeS[1] || 0)
		}

		return {
			url: "activity/Availability",
			body: {
				activityId: Number(activityId),
				startDateTime: new Date(startDate.toString().split("GMT")[0] + " UTC").toISOString(),
				endDateTime: new Date(endDate.toString().split("GMT")[0] + " UTC").toISOString(),
			},
		}
	},
})

export const useGetOverlay = connectorApiSlice.query({
	builder: () => {
		return {
			url: "overlay",
			params: {
				funnelToken: appStore.get("settings.funnelToken"),
				date: new Date().toISOString().slice(0, 10),
				languageCode: appStore.getState().core.languageCode,
			},
		}
	},
})

export const useCreateActivityReservation = connectorApiSlice.mutation({
	builder: ({ activityId, startDateTime, endDateTime }) => ({
		url: "activity/reservation",
		body: { activityId, startDateTime, endDateTime },
	}),
})

export const useGetCountries = connectorApiSlice.query({
	name: "GETCOUNTRIES",
	builder: () => ({
		url: "pos/country",
		params: {
			languageCode: appStore.getState().core.languageCode,
		},
	}),
	transformResponse: response => {
		if (response.succeed) {
			let data = response.data
			let index = data.findIndex(el => el.countryId === 60)
			let temp = data[index]
			data.splice(index, 1)

			data.sort((a, b) => {
				if (a.country < b.country) {
					return -1
				}
				if (a.country > b.country) {
					return 1
				}

				// names must be equal
				return 0
			})

			data = [temp, ...data]
			response.data = data
		}

		return response
	},
})

export const useGetTransporterCountries = connectorApiSlice.query({
	builder: ({ transporterIds }) => {
		return {
			url: "Sales/Transporter/Countries",
			params: {
				transporterIds: JSON.stringify(transporterIds),
				languageCode: appStore.get("core.languageCode"),
			},
		}
	},
	transformResponse: response => {
		if (response.succeed && Array.isArray(response.data)) {
			let data = [...response.data]

			let index = data.findIndex(el => el.countryId === 60)

			if (index !== -1) {
				// If countryId 60 exists, move it to the top
				let temp = data[index]
				data.splice(index, 1)
				data.sort((a, b) => a.country.localeCompare(b.country))
				data = [temp, ...data] // Add countryId 60 to the beginning
			} else {
				// If countryId 60 doesn't exist, return sorted data as is
				data.sort((a, b) => a.country.localeCompare(b.country))
			}
			response.data = data
		}

		return response
	},
})

export const useGetVisitorKinds = connectorApiSlice.query({
	name: "visitorKinds",
	method: "POST",
	builder: ({ zoneId, locationId }) => {
		let relation = appStore.get("core.relation")
		relation = relation && relation.guest ? undefined : relation
		return {
			url: "connector/visitor/kinds",
			body: {
				languageCode: appStore.getState().core.languageCode,
				zoneId: zoneId,
				locationId: locationId,
				relation: relation,
				funnelToken: appStore.get("settings.funnelToken"),
			},
		}
	},
	transformResponse: base => {
		if (base.succeed && base.data) {
			const next = [...base.data]
			next.forEach(e => {
				e.price = Math.floor(Math.random() * (40 - 15) + 15)
			})
			base.data = next
		}
		return base
	},
	providesTags: ["RELATION_TOKEN"],
})

export const useGetRelation = connectorApiSlice.query({
	name: "getRelation",
	builder: () => {
		return {
			url: "relation",
		}
	},
	transformResponse: rsp => {
		if (rsp.succeed) {
			const relation = appStore.get("core.relation") || {}
			appStore.set("core.relation", {
				...relation,
				...rsp.data,
			})
		}
		return rsp
	},
	providesTags: ["RELATION"],
})

export const useResetPassword = connectorApiSlice.mutation({
	builder: ({ email }) => ({
		url: "relation/password/reset",
		body: {
			userName: email,
		},
	}),
	transformResponse: response => {
		if (response.succeed) {
			tracking.forgotPassword()
		}
		return response
	},
})

export const useNewPassword = connectorApiSlice.mutation({
	builder: ({ newPassword, resetPasswordToken }) => ({
		url: "relation/password/save",
		body: {
			passwordResetToken: resetPasswordToken,
			password: newPassword,
		},
	}),
})
export const useRegister = connectorApiSlice.mutation({
	builder: ({ genderId, firstName, lastName, companyName, email, password, countryId, vatNumber, accountType, newsletterSignup, privacyConsent }) => {
		// const adressObj = splitStreetToParts(street);
		return {
			url: "relation",
			body: {
				relationTypeId: accountType === "firma" ? 2 : 1,
				firstName,
				lastName,
				companyName,
				email,
				password,
				genderId,
				// address: adressObj.street,
				// houseNo: adressObj.number + (adressObj.letter || ""),
				// zipCode,
				// city,
				countryId,
				vatNumber,
				newsletterSignup,
				privacyConsent,
			},
		}
	},
	transformResponse: response => {
		if (response.succeed) {
			tracking.signUpStart()
		}
		return response
	},
})
export const useConfirmAccount = connectorApiSlice.mutation({
	method: "PUT",
	builder: ({ confirmationCode, token }) => ({
		url: "relation/verification/verify",
		body: {
			token,
			code: confirmationCode,
		},
	}),
})

export const useCalendar = connectorApiSlice.mutation({
	builder: ({ locationId, zoneId, visitorKindIds, dateFrom, dateTo }) => {
		let relation = appStore.get("core.relation")
		relation = relation && relation.guest ? undefined : relation
		return {
			url: "connector/planning/calendar",
			body: {
				locationId,
				funnelToken: appStore.get("settings.funnelToken"),
				zoneId,
				visitorKinds: visitorKindIds,
				dateFrom: dateFrom,
				dateTo: dateTo,
				relation,
				languageCode: appStore.getState().core.languageCode,
				prepareTimePlanning: appStore.get("core.prepareTimePlanning"),
			},
		}
	},
	transformResponse: response => {
		if (!response.data || !Array.isArray(response.data)) {
			return response
		}
		for (let entry of response.data) {
			const isoString = entry.date + "T00:00:00"
			const date = new Date(isoString)
			entry.dateString = entry.date
			entry.date = date
		}
		//we filter all days that have an error message but not the one where the access is denied because auf the visitorKind selection
		response.data = response.data.filter(
			e => !e.message || e.message.startsWith("wrn.VisitorKind.NoAccess") || e.message.startsWith("wrn.TimePlanning.NotFound"),
		)
		return response
	},
})

export const useTimeblocks = connectorApiSlice.mutation({
	builder: ({ locationId, zoneId, visitorKindIds, dateString }) => {
		let relation = appStore.get("core.relation")
		relation = relation && relation.guest ? undefined : relation
		return {
			url: "connector/planning/timeblocks",
			body: {
				locationId,
				funnelToken: appStore.get("settings.funnelToken"),
				zoneId,
				date: dateString,
				visitorKinds: visitorKindIds,
				languageCode: appStore.getState().core.languageCode,
				relation,
				prepareTimePlanning: appStore.get("core.prepareTimePlanning"),
			},
		}
	},
	transformResponse: response => {
		// response.data = response.data.reverse();

		// /**
		//  * When we request timeblocks for the current date we want to filter
		//  * timeslots that are fully in the past.
		//  */
		// if (response.succeed) {
		//     let sCurrentDate = new Date().toISOString().slice(0, 10);
		//     if (sCurrentDate === dateString) {
		//         let sCurrentTime = new Date().toTimeString().split(" ")[0];
		//         for (let tbKind of response.data) {
		//             for (let tb of tbKind.timeBlocks) {
		//                 tb.timeSlots = tb.timeSlots.filter((ts) => {
		//                     let timeparts = ts.timeTo.split(":");
		//                     const x = new Date()
		//                     x.setHours(timeparts[0])
		//                     x.setMinutes(timeparts[1])
		//                     x.setSeconds(timeparts[2])
		//                     x.setMinutes(x.getMinutes() - 90);

		//                     timeparts = x.toTimeString().split(' ')[0].split(":")
		//                     let hour = Number(timeparts[0]);
		//                     if (hour < 10) {
		//                         hour = "0" + hour;
		//                     }

		//                     let timestring = [hour, timeparts[1], timeparts[2]].join(":");
		//                     return timestring >= sCurrentTime;
		//                 });
		//             }
		//         }

		//         let tbKindLength = response.data.length;
		//         while (tbKindLength--) {
		//             let tbLength = response.data[tbKindLength].timeBlocks.length;

		//             while (tbLength--) {
		//                 if (response.data[tbKindLength].timeBlocks[tbLength].timeSlots.length === 0) {
		//                     response.data[tbKindLength].timeBlocks.splice(tbLength, 1);
		//                 }
		//             }

		//             if (response.data[tbKindLength].timeBlocks.length === 0) {
		//                 response.data.splice(tbKindLength, 1);
		//             }
		//         }
		//     }
		// }

		return response
	},
})

export const useAvaiableObjects = connectorApiSlice.mutation({
	/**
	 *
	 * @param {{date: string}} param0
	 * @returns
	 */
	builder: ({ date }) => ({
		url: "map/object/available",
		params: {
			date,
		},
		body: {
			date,
		},
	}),
	transformResponse: rsp => {
		if (rsp.succeed) {
			if (!Array.isArray(rsp.data)) {
				rsp.data = []
			}
		}
		return rsp
	},
})

export const useGetCheckScanCode = connectorApiSlice.query({
	name: "testScanCode",
	builder: ({ scanCode, date }) => ({
		url: "ScanCode/Check",
		params: {
			scanCode: scanCode.trim(),
			date: date || new Date().toDateString(),
		},
	}),
	transformResponse: (response, calledArgs) => {
		response.data.scanCode = calledArgs.scanCode
		return response
	},
})
export const useCheckScanCode = connectorApiSlice.mutation({
	name: "testScanCode",
	method: "POST",
	builder: ({ scanCode, ignoreUsed }) => ({
		url: "ScanCode/Check",
		params: {
			scanCode: scanCode.trim(),
			date: new Date().toDateString(),
		},
		body: {
			options: {
				ignoreUsed,
			},
		},
	}),
	transformResponse: (response, calledArgs) => {
		if (!response.data.scanCode) {
			response.data.scanCode = calledArgs.scanCode.trim()
		}
		if (response.succeed) {
			if (response.data.details && response.data.details[0]) {
				let fd = response.data.details[0]
				if (fd.ids && fd.ids.length) {
					let hasEntry = fd.ids.every(e => appStore.get("settings.blockedVoucherDetailIds").indexOf(e.typeId) !== -1)
					if (hasEntry) {
						response.data.errorMessage = "wrn.Ticket.Blocked;internal"
						throw new ResponseError(response, calledArgs, "")
					}
				}
			}

			if (response.data.scanCode && calledArgs.ignoreUsed !== true) {
				//check if scancode is linked to a massage inside the state
				let massages = appStore.get("order.massages")
				let shoppingCart = appStore.get("order.shoppingCart") || []
				let isInside =
					massages.find(e => e.scanCodeLink === response.data.scanCode) ||
					shoppingCart.find(e => e.typeId === ORDER_LINE_TYPES.Activity && e.scanCodeLink === response.data.scanCode)
				if (isInside) {
					response.data.errorMessage = "wrn.Ticket.LinkedToMassage;internal"
					throw new ResponseError(response.url, response, calledArgs, "")
				}
			}
		}
		return response
	},
})

export const getFormattedOrderLines = paymentLine => {
	const timeSlotId = appStore.get("order.selectedTs.timeSlotId")
	const timeFrom = appStore.get("order.selectedTs.timeFrom")
	const timeTo = appStore.get("order.selectedTs.timeFrom")
	const timeBlock = appStore.get("order.selectedTb")
	const timeBlockId = appStore.get("order.selectedTb.timeBlockId")
	const timeBlockItems = timeBlock ? timeBlock.items : []
	const visitorKinds = appStore.get("order.visitorKinds")
	const date = appStore.get("order.selectedDay.date")
	const objectGroupOptions = JSON.parse(JSON.stringify(appStore.get("order.objectGroupOptions")))
	const priceActions = appStore.get("order.priceActions") || []
	let shoppingCart = [...(appStore.get("order.shoppingCart") || [])]
	const thermencardRefillInfo = appStore.get("order.thermencardRefillInfo")
	const orderKindId = appStore.get("core.funnel.orderKindIds") ? appStore.get("core.funnel.orderKindIds")[0] : undefined
	const availableLoungers = appStore.get("order.availableLoungers")
	const zoneId = appStore.get("core.zoneId")
	const relation = appStore.get("core.relation") ? { ...appStore.get("core.relation") } : {}
	const massages = appStore.get("order.massages")
	const connectedTransponder = appStore.get("order.connectedTransponder")
	const payment = appStore.get("order.payment")

	let deliveryAddress = appStore.get("core.deliveryAddress")
	let invoiceAddress = appStore.get("core.invoiceAddress")
	let addresses = deliveryAddress || invoiceAddress ? [] : undefined

	if (deliveryAddress) {
		addresses.push(deliveryAddress)
	}
	if (invoiceAddress) {
		addresses.push(invoiceAddress)
	}
	let mappedRelation = {
		...relation,
		languageCode: appStore.getState().core.languageCode,
	}
	if (addresses) {
		if (!mappedRelation.relationToken) {
			mappedRelation = {
				...mappedRelation,
				...addresses.find(e => e && e.addressTypeId == ADRESS_TYPES.INVOICE),
			}
		}
		mappedRelation.addresses = []
		let invoice = addresses.find(e => e && e.addressTypeId == ADRESS_TYPES.INVOICE)
		let delivery = addresses.find(e => e && e.addressTypeId == ADRESS_TYPES.DELIVERY)
		if (delivery && !delivery.isAmazon) {
			if (delivery.houseNumber) {
				delivery.houseNo = delivery.houseNumber
			}
			mappedRelation.addresses = [delivery]
		} else if ((delivery && delivery.isAmazon) || (invoice && invoice.isAmazon)) {
			mappedRelation.addresses = addresses
		}
		mappedRelation.addresses.push(invoice)
	}
	if (mappedRelation && mappedRelation.houseNumber) {
		mappedRelation.houseNo = mappedRelation.houseNumber
	}

	let orderLines = []

	if (timeBlock) {
		Object.keys(visitorKinds).forEach((key, mainIndex) => {
			const entry = visitorKinds[key]
			const {
				cnt: quantity,
				visitor: { visitorKindId },
				references,
			} = entry

			const { timeBlockPlanningId, timeBoxPlanningId, timeBlockTypeId } = timeBlock
			if (!timeBlockItems.find(e => e.visitorKindId === visitorKindId)) {
				const msg = "timeblock: " + JSON.stringify(timeBlock) + ";;;;;visitor: " + JSON.stringify(visitorKindId)

				throw new Error(msg)
			}
			const { ticketId, ticketPeriodId } = timeBlockItems.find(e => e.visitorKindId === visitorKindId)

			emptyArray(quantity).forEach((__, index) => {
				orderLines.push({
					date,
					ticketId,
					ticketPeriodId,
					quantity: 1,
					timeBlockPlanningId,
					timeBoxPlanningId,
					visitorKindId,
					timeSlotId,
					timeBlockId,
					timeFrom,
					timeTo,
					timeBlockTypeId,
					zoneId: appStore.get("core.zoneId"),
					typeId: ORDER_LINE_TYPES.Ticket,
					metaData: references[index] || undefined,
					relationTransponderId: connectedTransponder
						? connectedTransponder[mainIndex][index]
							? connectedTransponder[mainIndex][index].transponderId
							: undefined
						: undefined,
					transponderNumber: connectedTransponder
						? connectedTransponder[mainIndex][index]
							? connectedTransponder[mainIndex][index].transponderNumber
							: undefined
						: undefined,
				})
			})
		})
	}

	//add saved object group options
	objectGroupOptions.forEach(e => {
		e.quantity = 1
		e.dynamicPriceLevelId = availableLoungers?.find(a => a.objectGroupId === e.objectGroupId)?.dynamicPriceLevelId
		;((e.typeId = ORDER_LINE_TYPES.Object), (e.zoneId = zoneId))
	})

	orderLines.push(...objectGroupOptions)

	//add all products
	const products = appStore.get("order.products")
	Object.keys(products).forEach(key => {
		const entry = products[key]
		const {
			cnt: quantity,
			article: { articleId, voucherId, price },
		} = entry
		orderLines.push({
			quantity,
			articleId,
			voucherId,
			typeId: articleId ? ORDER_LINE_TYPES.Article : ORDER_LINE_TYPES.Voucher,
			price,
		})
	})

	//add parking tickets

	const parkingTickets = appStore.get("order.parkingTickets")
	Object.keys(parkingTickets).forEach(key => {
		const entry = parkingTickets[key]
		const {
			cnt: quantity,
			parkingTicket: { ticketId },
		} = entry
		orderLines.push({
			ticketId,
			quantity,
			date: date || new Date().toISOString().slice(0, 10),
			typeId: ORDER_LINE_TYPES.Ticket,
		})
	})

	massages.forEach(mass => {
		orderLines.push(mass)
	})

	shoppingCart.forEach(entry => {
		orderLines.push(entry)
	})

	//thermecard
	if (thermencardRefillInfo) {
		for (let refill of thermencardRefillInfo) {
			orderLines.push(refill)
		}
	}

	let realPriceActions = priceActions.filter(e => e.scanCodeTypeId === SCANCODE_TYPES.PRICEACTION || e.scanCodeTypeId === SCANCODE_TYPES.ARTICLE)
	let usedTickets = priceActions.filter(e => e.scanCodeTypeId === SCANCODE_TYPES.TICKET)
	let vouchers = priceActions.filter(e => e.scanCodeTypeId === SCANCODE_TYPES.VOUCHER)
	if (usedTickets && usedTickets.length) {
		usedTickets.forEach(ticket => {
			orderLines.push({
				...ticket,
				ticketId: ticket.ticketId,
				quantity: -1,
				date: ticket.dateFrom,
				scanCode: ticket.scanCode,
				typeId: ORDER_LINE_TYPES.Ticket,
				price: ticket.price,
			})
		})
	}

	if (paymentLine) {
		orderLines.push(paymentLine)
	}

	let accountToken = undefined
	if (payment && payment.type === PAYMENT_TYPES.Thermencard) {
		if (relation.thermencardAccount) {
			accountToken = relation.thermencardAccount.accountToken
		}
	}
	if (payment && payment.type === PAYMENT_TYPES.EmployeePoints) {
		if (relation.employeePoints) {
			accountToken = relation.employeePoints.accountToken
		}
	}

	// localStore.setItem("orderLines", JSON.stringify(orderLines))
	// localStore.setItem("priceActions", JSON.stringify(realPriceActions))

	return {
		date: new Date().toISOString().slice(0, 10),
		funnelToken: appStore.get("settings.funnelToken"),
		orderLines: orderLines,
		priceActions: realPriceActions,
		languageCode: appStore.getState().core.languageCode,
		orderKindId,
		relation: mappedRelation,
		vouchers,
		accountToken,
	}
}

export const useFormatOrder = connectorApiSlice.mutation({
	name: "formatOrder",
	builder: ({ paymentLine }) => {
		return {
			url: "connector/sales/order/format",
			body: getFormattedOrderLines(paymentLine),
		}
	},
	transformResponse: rsp => {
		if (rsp.succeed) {
			if (rsp.data.orderLines) {
				rsp.data.orderLines = mergeLinesToCollections(rsp.data)
			}
		}

		return rsp
	},
})

export const useSaveObjectGroupOptions = connectorApiSlice.mutation({
	builder: ({ loungers, dateString, selectedTags = [] }) => {
		const objectGroups = []
		for (let lounger of loungers) {
			let found = objectGroups.find(e => e.objectGroupId === lounger.objectGroupId)
			let c = found || {
				objectGroupId: lounger.objectGroupId,
				quantity: 0,
			}
			c.quantity++
			if (!found) {
				objectGroups.push(c)
			}
		}

		return {
			url: "Reservation/Object/Group/Option",
			body: {
				objectGroups,
				dateFrom: dateString,
				dateTo: dateString,
				date: dateString,
				selectedTags,
			},
		}
	},
})

export const useCheckBankAccountWithCode = connectorApiSlice.mutation({
	// @ts-ignore
	method: "GET",
	builder: ({ code }) => {
		return {
			url: "/bankaccount",
			params: {
				scanCode: code,
			},
		}
	},
})

export const useSaveObjectOptions = connectorApiSlice.mutation({
	builder: ({ objectIds, dateString }) => {
		return {
			url: "Reservation/Object/Option",
			body: {
				objectIds,
				date: dateString,
			},
		}
	},
})

export const useSaveOrder = connectorApiSlice.mutation({
	builder: ({ billingAddress, deliveryAddress, payPalWebToken, relationPaymentToken }) => {
		const formattedOrder = appStore.get("order.formattedOrder")
		const payment = appStore.get("order.payment")
		const paymentId = appStore.get("order.payment.paymentId") || formattedOrder.paymentId
		const paymentDetailIds = appStore.get("order.payment.paymentDetailIds") || []
		const relation = appStore.get("core.relation") ? { ...appStore.get("core.relation") } : {}
		const amazonCheckoutSessionId = appStore.get("core.amazonCheckoutSessionId")
		const { cashregisterToken } = appStore.get("core.cashregister") || {}
		const invoiceAddress = billingAddress ?? appStore.get("core.invoiceAddress")
		const storePayPal = appStore.get("order.storePayPal")
		deliveryAddress = deliveryAddress ?? appStore.get("core.deliveryAddress")
		let mappedRelation = {
			...relation,
			languageCode: appStore.getState().core.languageCode,
		}

		if (!appStore.get("core.kioskMode") && !appStore.get("core.employeeMode")) {
			//We override the relation if its not an account or the account has no valid lastName
			if (!mappedRelation.relationToken || !mappedRelation.lastName || mappedRelation.lastName.length === 0) {
				mappedRelation = {
					...mappedRelation,
					...invoiceAddress,
				}
			}
			if (invoiceAddress) {
				deliveryAddress = deliveryAddress ?? {}
			}
			for (let key in invoiceAddress) {
				if (deliveryAddress[key] === undefined) {
					deliveryAddress[key] = invoiceAddress[key]
				}
			}

			mappedRelation.addresses = [
				invoiceAddress
					? {
							...invoiceAddress,
							addressToken: undefined,
							addressId: undefined,
							save: false,
						}
					: null,
				deliveryAddress || invoiceAddress
					? {
							...(deliveryAddress || invoiceAddress),
							addressTypeId: ADRESS_TYPES.DELIVERY,
							addressToken: undefined,
							addressId: undefined,
							save: false,
						}
					: null,
			].filter(e => e)

			if (mappedRelation && mappedRelation.houseNumber) {
				mappedRelation.houseNo = mappedRelation.houseNumber
			}
			mappedRelation.addresses.forEach(addr => {
				addr.save = false
			})
		}

		let accountToken = undefined
		let accountPaymentId = undefined
		if (payment && payment.type === PAYMENT_TYPES.Thermencard) {
			if (relation.thermencardAccount) {
				accountToken = relation.thermencardAccount.accountToken
				accountPaymentId = relation.thermencardAccount.paymentId

				if (relation.thermencardAccount.amount < formattedOrder.payAmount) {
					throw new Error("not enough amount")
				}
			}
		}
		if (payment && payment.type === PAYMENT_TYPES.EmployeePoints) {
			if (relation.employeePoints) {
				accountToken = relation.employeePoints.accountToken
				accountPaymentId = relation.employeePoints.paymentId

				if (relation.employeePoints.amount < formattedOrder.payAmount) {
					throw new Error("not enough amount")
				}
			}
		}

		let lines2remove = []
		formattedOrder.orderLines.forEach(e => {
			if (e.bookingLifeTimeEnd) {
				let germanTime = new Intl.DateTimeFormat("en-US", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
					hour: "2-digit",
					minute: "2-digit",
					timeZone: "Europe/Berlin",
				})
				let x = new Date(e.bookingLifeTimeEnd)
				if (x.getTime() <= new Date(germanTime.format(new Date())).getTime()) {
					lines2remove.push(e)
				}
			}
		})

		if (lines2remove.length) {
			const error = new Error("err.massageLifetimeEnded")
			// @ts-ignore
			error.invalidLines = lines2remove
			throw error
		}

		const orderLines = []
		let orderLineCnt = formattedOrder.orderLines.length
		while (orderLineCnt--) {
			const lin = formattedOrder.orderLines[orderLineCnt]
			if (lin.typeId === ORDER_LINE_TYPES.Collection) {
				orderLines.push(...lin.details.map(e => ({ ...e, quantity: lin.quantity, details: [e] })).flat())
			} else {
				orderLines.push({ ...lin })
			}
		}
		let utmParams = JSON.parse(new URLSearchParams(window.location.search).get("hs_utm") || "{}")

		return {
			url: "Sales/Order",
			body: {
				cashregisterToken,
				paymentId: accountPaymentId ? accountPaymentId : paymentId,
				paymentDetailIds,
				accountToken,
				payPalWebToken,
				...{
					...formattedOrder,
					orderLines,
				},
				relation: mappedRelation,
				provider: amazonCheckoutSessionId
					? {
							providerToken: amazonCheckoutSessionId,
						}
					: undefined,
				relationPaymentToken: payment?.relationPaymentToken ?? relationPaymentToken,
				utm: utmParams,
				storePaymentMethod: storePayPal,
			},
		}
	},
	transformResponse: response => {
		if (response.status !== 200) return response

		localStore.removeItem("formattedOrder")
		localStore.removeItem("priceActions")

		if (window.self !== window.top) {
			if (response.succeed) {
				//execute all actions from rsp
				let actions = response.data?.register || {}
				Object.keys(actions).forEach(key => {
					KioskBridge.execute(key, actions[key]).catch(e => {
						console.error(e)
					})
				})
			}
		}

		return response
	},
})

export const useCheckVisitorKindRestrictions = connectorApiSlice.mutation({
	builder: () => {
		const visitorKinds = appStore.get("order.visitorKinds")
		let result = []
		Object.keys(visitorKinds).forEach(key => {
			const entry = visitorKinds[key]
			for (let i = 0; i < entry.cnt; i++) {
				result.push(entry.visitor.visitorKindId)
			}
		})

		return {
			url: "/Visitor/Kind/Check",
			body: {
				visitorKindIds: result,
				zoneId: appStore.get("core.zoneId"),
			},
		}
	},
})

export const useGetTransponder = connectorApiSlice.query({
	builder: () => {
		return {
			url: "/Transponder",
		}
	},
	providesTags: ["RELATION_TOKEN"],
})

export const useGetEmployeeNews = connectorApiSlice.query({
	builder: ({ messageId }) => {
		return {
			url: "/Message",
			params: messageId ? { messageId } : undefined,
		}
	},
	providesTags: ["RELATION_TOKEN"],
	transformResponse: rsp => {
		if (rsp.succeed && Array.isArray(rsp.data)) {
			rsp.data = rsp.data.filter(e => e.tags && e.tags.find(tag => tag.tag == "Employee") !== undefined)
			rsp.data = rsp.data.sort((a, b) => new Date(b.creationDateTime) - new Date(a.creationDateTime))
			rsp.data = rsp.data.slice(0, 5)
		}
		return rsp
	},
})

export const useStartVerificationByMail = connectorApiSlice.mutation({
	builder: ({ relationToken, email }) => {
		return {
			url: "/Relation/Verification/Email",
			body: {
				email,
				relationToken,
				languageCode: appStore.getState().core.languageCode,
			},
		}
	},
})

export const useGetNextSpecialDays = connectorApiSlice.query({
	builder: () => {
		return {
			url: "/specialday/next/zone",
		}
	},
})

export const useGetOrder = connectorApiSlice.query({
	builder: ({ webToken }) => {
		return {
			url: "/Sales/Order",
			params: {
				webToken,
				languageCode: appStore.getState().core.languageCode,
			},
		}
	},
})

export const useSaveUserData = connectorApiSlice.mutation({
	method: "PUT",
	builder: ({ genderId, firstName, lastName, companyName, vatNumber, phoneNo, accountType, countryId }) => {
		return {
			url: "relation",
			body: {
				relationTypeId: accountType && accountType === "firma" ? 2 : 1,
				firstName,
				lastName,
				companyName,
				genderId,
				vatNumber,
				phoneNo,
				countryId,
			},
		}
	},
	invalidatesTags: [],
})

export const useDeleteUserData = connectorApiSlice.mutation({
	method: "DELETE",
	builder: () => {
		return {
			url: "relation",
		}
	},
	transformResponse: response => {
		if (response.succeed) {
			tracking.deleteAccount()
			appStore.set(state => ({
				core: {
					...state.core,
					relation: undefined,
				},
			}))
		}
		return response
	},
})

export const useGetSignedAmazonPayPayload = connectorApiSlice.query({
	builder: ({ paymentId, payAmount }) => ({
		url: "amazon/pay/button",
		params: {
			paymentId,
			payAmount,
			languageCode: appStore.getState().core.languageCode,
		},
	}),
})

export const useGetAmazonSession = connectorApiSlice.query({
	builder: ({ paymentId, checkoutSessionId }) => ({
		url: "amazon/pay/session",
		params: {
			paymentId,
			checkoutSessionId,
		},
	}),
})

export const useVerfiyAmazonPayment = connectorApiSlice.mutation({
	builder: ({ checkoutSessionId }) => {
		return {
			url: "amazon/pay/complete",
			headers: {
				"Content-Type": "application/json",
			},
			body: {
				checkoutSessionId,
			},
		}
	},
})

export const useGetAmazonOrderStatus = connectorApiSlice.query({
	builder: ({ checkoutSessionId }) => {
		return {
			url: "Amazon/Pay/Status",
			headers: {
				"Content-Type": "application/json",
			},
			params: {
				checkoutSessionId,
			},
		}
	},
})

export const useGetOrderHistory = connectorApiSlice.query({
	builder: () => {
		return {
			url: "/Relation/Sales/History",
		}
	},
})
export const useGetFutureOrders = connectorApiSlice.query({
	builder: () => {
		return {
			url: "/Relation/Sales/History",
			params: {
				onlyFuture: true,
			},
		}
	},
})
export const useGetInvoicePdf = connectorApiSlice.query({
	builder: ({ webToken }) => {
		return {
			url: "/Invoice/Pdf",
			params: {
				webToken,
				languageCode: appStore.getState().core.languageCode,
			},
		}
	},
})
export const useGetVoucherPdf = connectorApiSlice.query({
	builder: ({ webToken }) => {
		return {
			url: "/Voucher/Pdf",
			params: {
				webToken,
				languageCode: appStore.getState().core.languageCode,
			},
		}
	},
})
export const useGetTicketPdf = connectorApiSlice.query({
	builder: ({ webToken }) => {
		return {
			url: "/Ticket/Pdf",
			params: {
				webToken,
				languageCode: appStore.getState().core.languageCode,
			},
		}
	},
})

export const useGetProfileImage = connectorApiSlice.query({
	builder: () => {
		return {
			url: "Relation/Picture",
		}
	},
})

export const useDeleteProfileImage = connectorApiSlice.mutation({
	method: "DELETE",
	builder: () => {
		return {
			url: "/Relation/Picture",
		}
	},
})

export const useGetMaps = connectorApiSlice.query({
	builder: ({ zoneId }) => ({
		url: "map",
		params: {
			zoneId: zoneId,
			languageCode: appStore.get("core.languageCode"),
		},
	}),
})
export const useGetHotspots = connectorApiSlice.query({
	builder: ({ zoneId }) => ({
		url: "hotspot",
		params: {
			zoneId: zoneId,
		},
	}),
	transformResponse: response => {
		if (response.succeed) {
			response.data = response.data ? (Array.isArray(response.data) ? response.data : []) : []
		}

		return response
	},
})

export const useGetObjects = connectorApiSlice.query({
	builder: ({ zoneId }) => ({
		url: "map/object",
		params: {
			zoneId: zoneId,
		},
	}),
	transformResponse: response => {
		if (response.succeed) {
			response.data = response.data ? (Array.isArray(response.data) ? response.data : []) : []
		}

		return response
	},
})

export const useSaveProfileImage = connectorApiSlice.mutation({
	method: "POST",
	builder: ({ image }) => {
		let form = new FormData()
		form.append("file", image)
		return {
			url: "/relation/picture",
			headers: {
				enctype: "multipart/form-data",
			},
			body: form,
		}
	},
})

export const useGetUserTransponder = connectorApiSlice.query({
	builder: () => {
		return {
			url: "/Transponder",
		}
	},
})

export const useSaveUserTransponder = connectorApiSlice.mutation({
	method: "POST",
	builder: ({ scanCode, email, firstName, lastName, birthDate, isDefault }) => {
		return {
			url: "/Transponder/HKS",
			body: {
				scanCode: scanCode,
				email: email,
				firstName: firstName,
				lastName: lastName,
				birthDate: birthDate,
				isDefault: isDefault,
			},
		}
	},
})

export const useDeleteUserTransponder = connectorApiSlice.mutation({
	method: "DELETE",
	builder: transponderId => ({
		url: "Transponder",
		params: {
			transponderId,
		},
	}),
})

export const useEditUserTranspoderData = connectorApiSlice.mutation({
	method: "PUT",
	builder: ({ transponderId, transponder, firstName, lastName, email, birthDate, isDefault }) => {
		return {
			url: "/Transponder",
			body: {
				transponderId: transponderId,
				transponder: transponder,
				firstName: firstName,
				lastName: lastName,
				email: email,
				birthDate: birthDate,
				isDefault: isDefault,
			},
		}
	},
})

export const useGetBankAccounts = connectorApiSlice.query({
	builder: () => {
		return {
			url: "/BankAccount",
		}
	},
	providesTags: ["RELATION_TOKEN"],

	transformResponse: rsp => {
		//just for testing purposes
		if (appStore.get("core.forceCardLock")) {
			if (rsp.succeed) {
				rsp.data.forEach(e => {
					if (e.lock == false) {
						e.lock = true
					}
				})
			}
		}

		return rsp
	},
})

export const useGetThermencardBankAccount = () => {
	const request = useGetBankAccounts()

	let data = request && request.data && Array.isArray(request.data) ? request.data.find(e => e.isEmployee == false) : undefined
	return { ...request, data }
}

export const useDeleteBankAccount = connectorApiSlice.mutation({
	method: "DELETE",
	builder: ({ accountId }) => {
		return {
			url: "/BankAccount",
			params: {
				accountId,
			},
		}
	},
})

export const useCreateNewBankAccount = connectorApiSlice.mutation({
	method: "POST",
	builder: ({ email, scanCode }) => {
		return {
			url: "/BankAccount/HKS",
			body: {
				accountTemplateId: 3,
				email: email,
				scanCode: scanCode,
			},
		}
	},
})

export const useSavePaymentMethod = connectorApiSlice.mutation({
	method: "POST",
	builder: ({ paymentDetailId, paymentId }) => {
		return {
			url: "Relation/Payment",
			body: {
				paymentId: paymentId,
				paymentDetailId: paymentDetailId,
			},
		}
	},
})
export const useGetPaymentMethods = connectorApiSlice.query({
	builder: () => {
		return {
			url: "Relation/Payment",
		}
	},
	transformResponse(rsp) {
		let d = rsp?.data

		rsp.data = Array.isArray(d) ? d : []
		return rsp
	},
})

export const useSaveFavoritePaymentMethod = connectorApiSlice.mutation({
	method: "PUT",
	builder: ({ relationPaymentId }) => {
		return {
			url: "Relation/Payment/Favorite",
			body: {
				relationPaymentId: relationPaymentId,
			},
		}
	},
})

export const useGetPricesPerZone = connectorApiSlice.query({
	name: "getPricesForZones",
	builder: () => {
		return {
			url: "connector/zone/prices",
			params: {
				languageCode: appStore.getState().core.languageCode,
				funnelToken: appStore.get("settings.funnelToken"),
			},
		}
	},
	transformResponse: response => {
		if (response.succeed) {
			response.data = Array.isArray(response.data) ? response.data : []
			response.data.forEach(e => {
				if (e.timeBlockKinds) {
					let e1 = e.timeBlockKinds.find(e => e.timeBlockKind === "Halbtageskarte")
					let e2 = e.timeBlockKinds.find(e => e.timeBlockKind === "Tageskarte")
					//Look for case where Halbtageskarte and Tageskarte both exist.Then merge the two objects to one to have them on the same line on zoneSelection page
					if (e1 && e2) {
						let temp = {
							timeBlockKind: `${e1.timeBlockKind}/${e2.timeBlockKind}`,
							minPrice: e1.minPrice,
						}
						e.timeBlockKinds.unshift(temp)
						let index1 = e.timeBlockKinds.indexOf(e1)
						e.timeBlockKinds.splice(index1, 1)
						let index2 = e.timeBlockKinds.indexOf(e2)
						e.timeBlockKinds.splice(index2, 1)
					}
				}
			})
		}

		return response
	},
})

export const useDeleteObjectOption = connectorApiSlice.mutation({
	method: "DELETE",
	builder: ({ objectOptionId }) => ({
		url: "Reservation/Object/Option",
		params: {
			objectOptionId: objectOptionId,
		},
	}),
	transformResponse: (response, { objectOptionId }) => {
		if (response) {
			appStore.set(state => {
				let objectGroupOptions = [...state.order.objectGroupOptions]
				let index = objectGroupOptions.indexOf(e => (e.objectOptionId = objectOptionId))
				if (index) {
					objectGroupOptions.splice(index, 1)
				}
				return {
					order: {
						...state.order,
						objectGroupOptions,
					},
				}
			})
		}

		return response
	},
})

export const useGetBankHistory = connectorApiSlice.query({
	builder: ({ scanCode, dateFrom, dateTo }) => {
		let d = new Date(dateTo)
		d.setDate(d.getDate() + 1)
		return {
			url: "/BankAccount/HKS/History",
			params: {
				scanCode,
				dateFrom,
				dateTo: d.toISOString().slice(0, 10),
			},
		}
	},
	transformResponse: rsp => {
		if (rsp.succeed) {
			let mappedEntries = groupBy(rsp.data.ValueCardBookings, "TimeStamp")
			rsp.data = mappedEntries
		}
		return rsp
	},
})

export const useGetPlanningObject = connectorApiSlice.query({
	builder: ({ date }) => {
		let headers = {}
		return {
			url: "/relation/planningObject",
			headers,
			params: {
				date: date,
				funnelToken: appStore.get("settings.funnelToken"),
			},
		}
	},
	providesTags: ["RELATION_TOKEN"],
	transformResponse: rsp => {
		if (rsp.succeed) {
			rsp.data.sort((a, b) => {
				if (a.timeFrom < b.timeFrom) {
					return -1
				} else if (a.timeFrom > b.timeFrom) {
					return 1
				} else {
					return 0
				}
			})
		}
		return rsp
	},
})

export const useSavePlanningObject = connectorApiSlice.mutation({
	builder: ({ planningObject }) => {
		let headers = {}
		return {
			url: "/relation/planningObject",
			headers: headers,
			body: planningObject,
		}
	},
})

export const useGetLoungerTags = connectorApiSlice.query({
	builder: ({ zoneId }) => {
		return {
			url: "Map/Object/Tag",
			params: {
				zoneId: zoneId,
				languageCode: appStore.get("core.languageCode"),
			},
		}
	},
	transformResponse: response => {
		if (response.succeed) {
			response.data = Array.isArray(response.data) ? response.data : []

			response.data.forEach(tag => (tag.tag = tag.translation || tag.tag))
		}
		return response
	},
})

export const useMapExternalCodes = connectorApiSlice.mutation({
	builder: ({ items }) => ({
		url: "connector/pos/ExternalCode",
		body: {
			items,
		},
	}),
})

export const useGetMapDecorations = connectorApiSlice.query({
	builder: () => ({
		url: "map/Decorations",
	}),
	transformResponse: response => {
		if (response.succeed) {
			response.data = response.data ? (Array.isArray(response.data) ? response.data : []) : []
		}

		return response
	},
})

export const useGetVisitorKindRules = connectorApiSlice.query({
	builder: ({ date }) => {
		return {
			url: "/visitor/kind/rules",
			params: {
				zoneId: null,
				date,
			},
		}
	},
})

export const useGetRelationAddresses = connectorApiSlice.query({
	builder: () => {
		return {
			url: "relation/address",
		}
	},
	providesTags: ["RELATION_ADDRESSES"],
})

export const useSaveRelationAddress = connectorApiSlice.mutation({
	builder: ({ address }) => {
		return {
			url: "relation/address",
			body: {
				relationId: appStore.get("relation.relationId"),
				addresses: [address],
			},
		}
	},
	invalidatesTags: ["RELATION_ADDRESSES", "RELATION"],
})

export const useDeleteRelationAddress = connectorApiSlice.mutation({
	method: "DELETE",
	builder: ({ addressId, addressToken }) => {
		return {
			url: "relation/address",
			params: {
				addressId,
				addressToken,
			},
		}
	},
	invalidatesTags: ["RELATION_ADDRESSES", "RELATION"],
})

export const useCheckRequiredVisitors = connectorApiSlice.mutation({
	method: "GET",
	builder: ({ scanCode }) => ({
		url: "Activity/CheckRequiredVisitors",
		params: {
			funnelToken: appStore.get("settings.funnelToken"),
			scanCode: scanCode,
		},
	}),
})
